// extracted by mini-css-extract-plugin
export default {"center":"Home_center__c0wn3","title":"Home_title__49oHQ"};